if (!Array.prototype.forEach) {
  Array.prototype.forEach = function(fn, scope) {
    'use strict'
    var i, len
    for (i = 0, len = this.length; i < len; ++i) {
      if (i in this) {
        fn.call(scope, this[i], i, this)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/polyfills/array/forEach.js